import Button from '@oberoninternal/travelbase-ds/components/action/Button';
import { Maybe } from '@oberoninternal/travelbase-ds/entities/Maybe';
import { Sesame } from '@oberoninternal/travelbase-ds/hooks/useSesame';
import React, { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { TransformFragment } from '../generated/graphql';
import ContentWrapper from './ContentWrapper';
import Carousel from './designsystem/Carousel';
import PhotoModal from './designsystem/PhotoModal';
import Section from './designsystem/Section';
import Tile from './designsystem/Tile';

type Photo = {
    jpegTile?: Maybe<TransformFragment>;
    webpTile?: Maybe<TransformFragment>;
    jpegGallery?: Maybe<TransformFragment>;
    webpGallery?: Maybe<TransformFragment>;
};

interface Props extends Pick<Sesame, 'onOpen' | 'onClose' | 'open'> {
    photos: Array<Photo>;
}

const PhotoSection: FC<React.PropsWithChildren<Props>> = ({ photos, onOpen, onClose, open }) => {
    const [startIndex, setStartIndex] = useState(0);

    const onModalClose = () => {
        onClose();
        setStartIndex(0);
    };

    if (!photos.length) {
        return null;
    }

    return (
        <Section id="photos" className="gt-xs">
            <ContentWrapper>
                <Carousel title={<FormattedMessage defaultMessage="Foto's" />} continuous>
                    {photos.map(({ jpegTile, webpTile }, imageIndex) => {
                        if (!jpegTile || !webpTile) {
                            return null;
                        }
                        return (
                            <Wrapper
                                key={jpegTile?.src}
                                onClick={() => {
                                    setStartIndex(imageIndex);
                                    onOpen();
                                }}
                            >
                                <Tile loading="lazy" jpeg={jpegTile} webp={webpTile} />
                            </Wrapper>
                        );
                    })}
                </Carousel>
                <div>
                    <Button onClick={onOpen} variant="outline">
                        <FormattedMessage defaultMessage="Foto's bekijken" />
                    </Button>
                </div>
                <PhotoModal
                    startIndex={startIndex}
                    open={open}
                    onClose={onModalClose}
                    imagesOrCategories={photos.map(({ webpGallery, jpegGallery }) => ({
                        jpeg: jpegGallery,
                        webp: webpGallery,
                    }))}
                />
            </ContentWrapper>
        </Section>
    );
};

export default PhotoSection;

const Wrapper = styled.div`
    scroll-snap-align: start;
    cursor: pointer;

    & + & {
        margin-left: 3.2rem;
    }

    &:last-child {
        margin-right: 3.2rem;
    }
`;
